(function () {
  'use strict';

  var VARIANT_FIELDS = ['uses', 'height', 'sizes', 'custom'];
  var DYNAMIC_FIELDS = ['height', 'sizes', 'custom', 'features'];
  var HEIGHT_ORDER = [
    'Up to 14 cm',
    '15 to 20 cm',
    '21 to 25 cm',
    '26 to 35 cm',
    '36 cm or more'
  ];

  function split(value) {
    return String(value || '')
      .split('|')
      .map(function (item) { return item.trim(); })
      .filter(Boolean);
  }

  function list(value) {
    if (Array.isArray(value)) {
      return value.map(String).map(function (item) { return item.trim(); }).filter(Boolean);
    }
    if (value === true || value === false) return [String(value)];
    if (value === null || typeof value === 'undefined') return [];
    return [String(value).trim()].filter(Boolean);
  }

  function norm(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  function phraseKey(value) {
    return norm(value).replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function addAliases(map, label, aliases) {
    aliases.forEach(function (alias) {
      map[phraseKey(alias)] = label;
    });
  }

  function variants(card) {
    var node = card.querySelector('[data-box-variants]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent) || [];
    } catch (error) {
      return [];
    }
  }

  function hasValue(values, selected) {
    return list(values).map(norm).indexOf(norm(selected)) !== -1;
  }

  function isTrue(value) {
    return value === true || norm(value) === 'true' || norm(value) === '1';
  }

  function isAddOnVariant(variant) {
    return isTrue(variant.addOn);
  }

  function modularUseMode(record, selected) {
    if (!record || norm(record.role) !== 'modular' || !selected || !selected.uses) {
      return '';
    }

    var use = norm(selected.uses);
    if (use === norm('One-tier cakes') || use === norm('Two-tier cakes')) {
      return 'base';
    }
    if (use === norm('Wedding cakes') ||
        use === norm('Cakes with three or more tiers')) {
      return 'addon';
    }
    return '';
  }

  function variantValues(variant, field, record, selected) {
    var modularMode = modularUseMode(record, selected);

    if (field === 'height' && modularMode === 'base') {
      return list(variant.height);
    }
    if (field === 'height' && modularMode === 'addon') {
      return isAddOnVariant(variant) ? list(variant.combinedHeight) : [];
    }
    if (field === 'height' && isAddOnVariant(variant)) {
      return list(variant.combinedHeight);
    }
    return list(variant[field]);
  }

  function selectedValues(selects) {
    var selected = {};
    selects.forEach(function (select) {
      selected[select.dataset.boxFilter] = select.value;
    });
    return selected;
  }

  function variantMatches(record, variant, selected, excludedField, fields) {
    var modularMode = modularUseMode(record, selected);

    return (fields || VARIANT_FIELDS).every(function (field) {
      if (field === excludedField || !selected[field]) return true;
      if (field === 'uses' && modularMode === 'addon') {
        return isAddOnVariant(variant);
      }
      return hasValue(variantValues(variant, field, record, selected), selected[field]);
    });
  }

  function recordMatches(record, selected, excludedField) {
    if (excludedField !== 'features' && selected.features &&
        !hasValue(record.features, selected.features)) {
      return false;
    }

    var activeVariantFilters = VARIANT_FIELDS.filter(function (field) {
      return field !== excludedField && Boolean(selected[field]);
    });

    if (!activeVariantFilters.length) return true;

    var orderedVariants = record.variants.slice().sort(function (a, b) {
      return Number(isAddOnVariant(b)) - Number(isAddOnVariant(a));
    });

    return orderedVariants.some(function (variant) {
      return variantMatches(record, variant, selected, excludedField, VARIANT_FIELDS);
    });
  }

  function matchingVariants(record, selected, excludedField) {
    if (!record) return [];
    if (excludedField !== 'features' && selected.features &&
        !hasValue(record.features, selected.features)) {
      return [];
    }
    return record.variants.filter(function (variant) {
      return variantMatches(record, variant, selected, excludedField, VARIANT_FIELDS);
    }).sort(function (a, b) {
      return Number(isAddOnVariant(b)) - Number(isAddOnVariant(a));
    });
  }

  function recordRequiresAddOn(record, selected) {
    if (modularUseMode(record, selected) === 'base') return false;
    return matchingVariants(record, selected, null).some(function (variant) {
      return isAddOnVariant(variant);
    });
  }

  function solutionVariant(record, selected) {
    if (modularUseMode(record, selected) === 'base') return null;
    return matchingVariants(record, selected, null).find(function (variant) {
      return isAddOnVariant(variant);
    }) || null;
  }

  function isRequiredAddOnRecord(addon, record) {
    if (!addon || !record) return false;
    if (addon.id && record.productId === String(addon.id)) return true;
    return Boolean(addon.handle) &&
      norm(record.productHandle) === norm(addon.handle);
  }

  function isPrimaryRecord(record) {
    if (record.variants.some(isAddOnVariant)) return true;
    return record.role !== 'extender' && record.role !== 'dowels';
  }

  function numbers(value) {
    return (String(value || '').match(/\d+(?:[.,]\d+)?/g) || []).map(function (number) {
      return Number(number.replace(',', '.'));
    });
  }

  function addOption(seen, field, value) {
    var clean = String(value || '').trim();
    if (!clean) return;
    if (field === 'height' && !HEIGHT_ORDER.some(function (height) {
      return norm(height) === norm(clean);
    })) return;
    if (field === 'custom') {
      var custom = norm(clean);
      if (custom === 'true' || custom === 'false') seen[custom] = custom;
      return;
    }
    seen[clean] = clean;
  }

  function collectOptions(field, primaryRecords, selected) {
    var seen = {};

    primaryRecords.forEach(function (record) {
      if (field === 'features') {
        if (!recordMatches(record, selected, 'features')) return;
        record.features.forEach(function (value) { addOption(seen, field, value); });
        return;
      }

      if (selected.features && !hasValue(record.features, selected.features)) return;

      record.variants.forEach(function (variant) {
        if (!variantMatches(record, variant, selected, field, VARIANT_FIELDS)) return;
        variantValues(variant, field, record, selected).forEach(function (value) {
          addOption(seen, field, value);
        });
      });
    });

    return Object.keys(seen);
  }

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';

    var cards = [].slice.call(root.querySelectorAll('[data-box-card]'));
    var selects = [].slice.call(root.querySelectorAll('[data-box-filter]'));
    var dynamicSelects = selects.filter(function (select) {
      return select.dataset.dynamic === 'true';
    });
    var count = root.querySelector('[data-box-count]');
    var countLabel = root.querySelector('[data-box-count-label]');
    var empty = root.querySelector('[data-box-empty]');
    var clear = root.querySelector('[data-box-clear]');
    var productGrid = root.querySelector('.dasbi-box-products');
    var viewProductLabel = root.getAttribute('data-view-product') || 'View product';

    var records = cards.map(function (card) {
      return {
        card: card,
        role: card.dataset.role || '',
        productId: String(card.dataset.productId || ''),
        productHandle: String(card.dataset.productHandle || ''),
        features: split(card.dataset.features),
        variants: variants(card)
      };
    });

    var primaryRecords = records.filter(isPrimaryRecord);

    var featureLabels = {};
    addAliases(featureLabels, root.getAttribute('data-feature-minimalist'), [
      'Minimalist design'
    ]);
    addAliases(featureLabels, root.getAttribute('data-feature-reveal'), [
      'Reveal opening',
      'Reveal effect opening',
      'Opening with reveal effect',
      'Surprise opening'
    ]);
    addAliases(featureLabels, root.getAttribute('data-feature-gift-ready'), [
      'Gift-ready design',
      'Gift ready design',
      'Gift-ready'
    ]);
    addAliases(featureLabels, root.getAttribute('data-feature-display'), [
      'Display-focused design',
      'Display focused design',
      'Display design'
    ]);
    addAliases(featureLabels, root.getAttribute('data-feature-compostable'), [
      'Compostable'
    ]);
    addAliases(featureLabels, root.getAttribute('data-feature-board-reducer'), [
      'Cake board reducer included',
      'Cake-board reducer included',
      'Cakeboard reducer included'
    ]);

    var heightLabels = {};
    heightLabels[phraseKey('Up to 14 cm')] = root.getAttribute('data-height-up-to-14');
    heightLabels[phraseKey('15 to 20 cm')] = root.getAttribute('data-height-15-20');
    heightLabels[phraseKey('21 to 25 cm')] = root.getAttribute('data-height-21-25');
    heightLabels[phraseKey('26 to 35 cm')] = root.getAttribute('data-height-26-35');
    heightLabels[phraseKey('36 cm or more')] = root.getAttribute('data-height-36-or-more');

    var solutionLabels = {};
    addAliases(solutionLabels, root.getAttribute('data-solution-up-to-60'), [
      'Up to 60cm',
      'Up to 60 cm'
    ]);
    addAliases(solutionLabels, root.getAttribute('data-solution-up-to-70'), [
      'Up to 70cm',
      'Up to 70 cm'
    ]);
    addAliases(solutionLabels, root.getAttribute('data-solution-board-reducer'), [
      'Cake board reducer included',
      'Cake-board reducer included',
      'Cakeboard reducer included'
    ]);

    var solutionNotes = {};
    addAliases(solutionNotes, root.getAttribute('data-solution-extender-note'), [
      'With compatible extender. Extender sold separately',
      'With compatible extender. Extender sold separately.'
    ]);
    var requiresModularNote = root.getAttribute('data-solution-requires-modular-note');
    addAliases(solutionNotes, requiresModularNote, [
      'Requires a compatible Modular Box, sold separately',
      'Requires a compatible Modular Box, sold separately.'
    ]);
    addAliases(solutionNotes, root.getAttribute('data-solution-dowels-note'), [
      'Can reach up to 70 cm with Dasbi 50 cm dowels, sold separately',
      'Can reach up to 70 cm with Dasbi 50 cm dowels, sold separately.'
    ]);
    addAliases(solutionNotes, root.getAttribute('data-solution-board-reducer'), [
      'Cake board reducer included',
      'Cake board reducer included.'
    ]);

    var customSelect = selects.find(function (select) {
      return select.dataset.boxFilter === 'custom';
    });
    var customLabels = {
      true: customSelect && customSelect.querySelector('option[value="true"]')
        ? customSelect.querySelector('option[value="true"]').textContent : 'Yes',
      false: customSelect && customSelect.querySelector('option[value="false"]')
        ? customSelect.querySelector('option[value="false"]').textContent : 'No'
    };

    function optionLabel(field, value) {
      if (field === 'height' && heightLabels[phraseKey(value)]) return heightLabels[phraseKey(value)];
      if (field === 'features' && featureLabels[phraseKey(value)]) return featureLabels[phraseKey(value)];
      if (field === 'custom' && customLabels[norm(value)]) return customLabels[norm(value)];
      return value;
    }

    function sortOptions(field, values) {
      return values.sort(function (a, b) {
        if (field === 'height') {
          var aIndex = HEIGHT_ORDER.map(norm).indexOf(norm(a));
          var bIndex = HEIGHT_ORDER.map(norm).indexOf(norm(b));
          if (aIndex === -1) aIndex = 999;
          if (bIndex === -1) bIndex = 999;
          if (aIndex !== bIndex) return aIndex - bIndex;
        }

        if (field === 'custom') {
          return (norm(a) === 'true' ? 0 : 1) - (norm(b) === 'true' ? 0 : 1);
        }

        if (field === 'sizes') {
          var aNumbers = numbers(a);
          var bNumbers = numbers(b);
          if (aNumbers.length && bNumbers.length && aNumbers[0] !== bNumbers[0]) {
            return aNumbers[0] - bNumbers[0];
          }
        }

        return optionLabel(field, a).localeCompare(optionLabel(field, b));
      });
    }

    function rebuildSelect(select, values) {
      var field = select.dataset.boxFilter;
      var previous = select.value;
      var sorted = sortOptions(field, values.slice());

      while (select.options.length > 1) select.remove(1);

      sorted.forEach(function (value) {
        var option = document.createElement('option');
        option.value = value;
        option.textContent = optionLabel(field, value);
        select.appendChild(option);
      });

      var replacement = sorted.find(function (value) {
        return norm(value) === norm(previous);
      });

      select.value = replacement || '';
      return Boolean(previous) && !replacement;
    }

    function refreshDynamicOptions() {
      var reset;
      var guard = 0;

      do {
        reset = false;
        var selected = selectedValues(selects);

        DYNAMIC_FIELDS.forEach(function (field) {
          var select = dynamicSelects.find(function (candidate) {
            return candidate.dataset.boxFilter === field;
          });
          if (!select) return;
          var values = collectOptions(field, primaryRecords, selected);
          if (rebuildSelect(select, values)) reset = true;
          selected = selectedValues(selects);
        });

        guard += 1;
      } while (reset && guard < 6);
    }

    function setVisible(record, visible) {
      record.card.hidden = !visible;
    }

    function setSolution(record, variant) {
      var solution = record.card.querySelector('[data-box-solution]');
      if (!solution) return;

      var label = solution.querySelector('[data-box-solution-label]');
      var note = solution.querySelector('[data-box-solution-note]');
      var rawLabel = variant ? String(variant.solutionLabel || '').trim() : '';
      var rawNote = variant ? String(variant.solutionNote || '').trim() : '';
      var rawNoteKey = phraseKey(rawNote);
      var labelText = rawLabel ? solutionLabels[phraseKey(rawLabel)] || rawLabel : '';
      var noteText = rawNote ? solutionNotes[rawNoteKey] || rawNote : '';

      if (rawNote && requiresModularNote &&
          rawNoteKey.indexOf('requires a compatible') === 0 &&
          rawNoteKey.indexOf('modular box sold separately') !== -1) {
        noteText = requiresModularNote;
      }

      if (label) {
        label.textContent = labelText;
        label.hidden = !labelText;
      }
      if (note) {
        note.textContent = noteText;
        note.hidden = !noteText;
      }
      solution.hidden = !variant || (!labelText && !noteText);
    }

    function createRequiredAddOnRecord(addon) {
      if (!productGrid || !addon) return null;

      var addonUrl = addon.url || (addon.handle ? '/products/' + addon.handle : '');
      if (!addonUrl) return null;

      var card = document.createElement('article');
      card.className = 'dasbi-box-product';
      card.dataset.boxCard = '';
      card.dataset.role = 'referenced-addon';
      card.dataset.productId = addon.id ? String(addon.id) : '';
      card.dataset.productHandle = addon.handle ? String(addon.handle) : '';
      card.hidden = true;

      var media = document.createElement('a');
      media.className = 'dasbi-box-product__media';
      media.href = addonUrl;
      if (addon.image) {
        var image = document.createElement('img');
        image.src = addon.image;
        image.alt = addon.title || '';
        image.loading = 'lazy';
        image.width = 800;
        image.height = 800;
        media.appendChild(image);
      }
      card.appendChild(media);

      var body = document.createElement('div');
      body.className = 'dasbi-box-product__body';
      var heading = document.createElement('h3');
      var titleLink = document.createElement('a');
      titleLink.href = addonUrl;
      titleLink.textContent = addon.title || String(addon.handle || '').replace(/-/g, ' ');
      heading.appendChild(titleLink);
      body.appendChild(heading);

      var price = document.createElement('p');
      price.className = 'dasbi-box-product__meta';
      price.textContent = addon.price || '';
      body.appendChild(price);

      var button = document.createElement('a');
      button.className = 'dasbi-box-button dasbi-box-button--small';
      button.href = addonUrl;
      button.textContent = viewProductLabel;
      body.appendChild(button);
      card.appendChild(body);
      productGrid.appendChild(card);

      var record = {
        card: card,
        role: 'referenced-addon',
        productId: addon.id ? String(addon.id) : '',
        productHandle: addon.handle ? String(addon.handle) : '',
        features: [],
        variants: []
      };
      records.push(record);
      return record;
    }

    function requiredAddOnRecord(variant) {
      var addon = variant && variant.requiredAddOn;
      if (!addon) return null;

      var existing = records.find(function (record) {
        return isRequiredAddOnRecord(addon, record);
      });

      return existing || createRequiredAddOnRecord(addon);
    }

    function apply() {
      var selected = selectedValues(selects);
      var active = Object.keys(selected).some(function (field) {
        return Boolean(selected[field]);
      });
      var visibleRecords = [];

      records.forEach(function (record) {
        setVisible(record, false);
        setSolution(record, null);
      });

      if (!active) {
        records.forEach(function (record) {
          setVisible(record, true);
          visibleRecords.push(record);
        });
      } else {
        primaryRecords.forEach(function (record) {
          if (!recordMatches(record, selected)) return;
          setVisible(record, true);
          visibleRecords.push(record);
        });

        visibleRecords.slice().forEach(function (record) {
          var variant = solutionVariant(record, selected);
          if (!variant) return;

          setSolution(record, variant);

          var addon = requiredAddOnRecord(variant);
          if (!addon || visibleRecords.indexOf(addon) !== -1) return;

          setVisible(addon, true);
          visibleRecords.push(addon);
        });
      }

      count.textContent = visibleRecords.length;
      if (countLabel) {
        countLabel.textContent = visibleRecords.length === 1
          ? countLabel.dataset.singular
          : countLabel.dataset.plural;
      }
      empty.hidden = visibleRecords.length !== 0;
      if (productGrid) productGrid.scrollLeft = 0;
    }

    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        refreshDynamicOptions();
        apply();
      });
    });

    if (clear) {
      clear.addEventListener('click', function () {
        selects.forEach(function (select) { select.value = ''; });
        refreshDynamicOptions();
        apply();
      });
    }

    refreshDynamicOptions();
    apply();
  }

  function all(scope) {
    (scope || document).querySelectorAll('[data-dasbi-catalogue]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { all(document); });
  } else {
    all(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    all(event.target);
  });
})();
